<template>
  <v-card flat class="pa-4">
    <h3 class="mb-3">Actividad de Likes</h3>

    <!-- Filtro por categoría -->
    <v-row class="mb-3">
      <v-col cols="12" sm="4">
        <v-select v-model="filtroCategoria" :items="categorias"
          item-text="name" item-value="id" label="Filtrar por categoría"
          outlined dense hide-details clearable prepend-inner-icon="mdi-filter">
        </v-select>
      </v-col>
      <v-col cols="12" sm="4">
        <v-text-field v-model="busqueda" label="Buscar usuario o post"
          outlined dense hide-details prepend-inner-icon="mdi-magnify" clearable>
        </v-text-field>
      </v-col>
    </v-row>

    <!-- Tabla -->
    <v-data-table
      :headers="headers"
      :items="likes"
      :search="busqueda"
      :loading="loading"
      loading-text="Cargando actividad..."
      no-data-text="No hay likes registrados"
      class="elevation-1"
      :footer-props="{ 'items-per-page-options': [10, 20, 50] }"
    >
      <template v-slot:item.fecha="{ item }">
        {{ formatDate(item.fecha) }}
      </template>
      <template v-slot:item.categoria="{ item }">
        <v-chip small color="grey darken-3" dark>{{ item.categoria }}</v-chip>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import forumService from '@/services/forumService.js';

export default {
  name: 'ForumActivityAdmin',
  data() {
    return {
      likes: [],
      categorias: [],
      filtroCategoria: null,
      busqueda: '',
      loading: false,
      headers: [
        { text: 'Usuario', value: 'usuario' },
        { text: 'Email', value: 'email' },
        { text: 'Post', value: 'post' },
        { text: 'Categoría', value: 'categoria' },
        { text: 'Fecha', value: 'fecha' }
      ]
    };
  },
  watch: {
    filtroCategoria() {
      this.cargarLikes();
    }
  },
  mounted() {
    this.cargarCategorias();
    this.cargarLikes();
  },
  methods: {
    cargarCategorias() {
      forumService.listarCategorias().then(res => {
        this.categorias = res.data;
      });
    },
    cargarLikes() {
      this.loading = true;
      const params = {};
      if (this.filtroCategoria) {
        params.category_id = this.filtroCategoria;
      }
      forumService.getLikesActivity(params).then(res => {
        this.likes = res.data.data || res.data;
      }).finally(() => {
        this.loading = false;
      });
    },
    formatDate(dateStr) {
      if (!dateStr) return '';
      const d = new Date(dateStr);
      return d.toLocaleDateString('es', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
    }
  }
};
</script>
